import script from "./register.vue?vue&type=script&setup=true&lang=ts"
export * from "./register.vue?vue&type=script&setup=true&lang=ts"

import "./register.vue?vue&type=style&index=0&id=50934740&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50934740"]])

export default __exports__